//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parse } from 'path';
export default {
    name: "alliance_bindshop",
    data() {
        return {
            title: "绑定门店",
            url: window.location.href,
            showAlert:false,//弹窗是否显示
            codeImg:'',//二维码图片
            timestamp:'',//时间戳
            ac_id:"",//用户id
        };
    },
    computed: {},
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.user_code();
        }

    },
    methods: {
        // 获取token
        get_token(url) {
            var self=this;
            this.$EpetJs.Common.approve(url,function() {
                self.user_code();
            }); //生成token

        },
        //生成用户二维码
        user_code() {
            var self = this;
            this.$EpetJs.Common.get(
                "/v2/public/user/qrcode",{}
            ).then(({ data }) => {
                if (data.status_code == "200") {
                   self.codeImg=data.data.base64;
                   self.timestamp=data.data.timestamp;
                   self.ac_id=data.data.ac_id;
                   //sse监听
                   if (typeof(EventSource) !== "undefined") {
                    // 'http://alliance-api.dev.haijipet.com/v2/sse/user/bind'
                    //self.$EpetJs.Const.PROTOCOL+"//"+self.$EpetJs.Const.API_PATH+self.$EpetJs.Const.DOMAIN
                        var urlGet=self.$EpetJs.Const.PROTOCOL+"//"+self.$EpetJs.Const.API_PATH+self.$EpetJs.Const.DOMAIN;
                        let source = new EventSource(urlGet+'/v2/sse/user/bind');
                        if(source.readyState!=2){//1表示链接成功
                            source.onmessage = function(data) {
                                if(data.data!='[]'){
                                    var dataAll=JSON.parse(data.data)//字符串转换成对象
                                    if(self.timestamp==dataAll.timestamp && self.ac_id==dataAll.ac_id){
                                        source.close();
                                        self.showAlert=true;
                                    }
                                }
                            }
                        };
                     }
                    }else{
                        self.$vux.toast.text('你的浏览器不支持server-sent事件');

                    }
                });
        },
        //去我的门店
        go_mystore(){
            this.$router.push({name:'alliance_mystore'})
        },
    }
};
